export default __webpack_public_path__ + "static/media/PolymerChainsImg.77af176d.jpg";